import { useContext } from "react";
import { WebActionType } from "../../schemas/Actions";
import { ActionDispatcherContext } from "./context";
export const useActionReducer = () => {
    const context = useContext(ActionDispatcherContext);
    if (!context) {
        throw new Error("useActionReducer needs to be used within a ActionContextReducer context");
    }
    return context;
};
export const actionReducer = (state, action) => {
    switch (action?.type) {
        case WebActionType.Weblink:
            if (action.requiresAuthentication) {
                return actionReducer(state, { type: WebActionType.ShowRsoModal, payload: { url: action.payload?.url } });
            }
            if (action.payload.isExternal) {
                window.open(action.payload.url, "_blank");
            }
            else if (window.isStorybookPreview && window.top) {
                window.top.location.href = action.payload.url;
            }
            else {
                window.location.href = action.payload.url;
            }
            return state;
        case WebActionType.YoutubeVideo:
            return {
                showLightbox: true,
                lightboxType: "youtube_video_embed",
                url: `https://youtube.com/embed/${action.payload.youtubeId}/`,
            };
        case WebActionType.ImageViewer:
            return { showLightbox: true, lightboxType: "image", asset: action.payload.image };
        case WebActionType.MediaViewer:
            return { showLightbox: true, lightboxType: "media", media: action.payload.media };
        case "close_lightbox":
            return { showLightbox: false, url: "" };
        case WebActionType.ShowRsoModal:
            return { showModal: true, modalType: "login", protectedUrl: action.payload?.url };
        case "close_modal":
            return { showModal: false, modalType: "" };
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map